import { useQuery } from '@tanstack/react-query';
import { RouteComponentProps } from 'react-router-dom';
import { API } from 'api';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { parseGeoEventDates } from 'features/geoEvents/geoEvent.utils';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { AxiosResponse } from 'axios';
import { WithStringDates } from 'shared/types';
import { EmbedGeoEvent } from './EmbedGeoEvent';

const fetchGeoEvent = async (
  geoEventId: string,
): Promise<AxiosResponse<Wildfire>> => {
  const res = await API.get<WithStringDates<Wildfire>>(
    `geo_events/${geoEventId}`,
  );
  return { ...res, data: parseGeoEventDates(res.data) };
};

export const GeoEventEmbed = (
  props: RouteComponentProps<{ geoEventId: string }>,
): JSX.Element => {
  const {
    match: {
      params: { geoEventId },
    },
  } = props;

  const query = useQuery({
    queryKey: ['geoEvent', geoEventId],
    queryFn: () => fetchGeoEvent(geoEventId),
  });

  const { data, isLoading, isError } = query;
  const geoEvent = data?.data;

  const status = getPageStatus({
    isLoading,
    isError: isError || !geoEvent,
  });

  return (
    // default header bar (drawer toggle only, no title/back action)
    <PageLayout data-cname="GeoEventEmbed" status={status} headerBarProps={{}}>
      {geoEvent && <EmbedGeoEvent geoEvent={geoEvent} />}
    </PageLayout>
  );
};
